import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NavigationExtras, Router } from '@angular/router';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { BulkInsertModel } from 'src/app/core/models/impact-assessment/bulk-insert-model';
import { ImpactAssessmentT5, ImpactAssessmentT5DetailListModel, ImpactAssessmentT5DetailsDD, ImpactAssessmentT5DropDownList, RagRating, UpdateImpactAssessmentT5Model } from 'src/app/core/models/impact-assessment/impact-assessmentT5';
import { JurisdictionsList } from 'src/app/core/models/impact-assessment/jurisdictions-list-model';
import { LinkedIdModel } from 'src/app/core/models/impact-assessment/linked-id-model';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { UserProfile } from 'src/app/core/models/user';
import { UserDetailModel } from 'src/app/core/models/user-management/user-filter-model';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { CommonService } from 'src/app/core/services/common/common.service';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { GDPRService } from 'src/app/core/services/rulebook';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { MasterHelper } from 'src/app/core/utilities';
import { DeleteDialogComponent } from 'src/app/views/distributed-ui-components';
import { TimePickerComponent } from '../../time-picker/time-picker.component';
import { RegulationDetail, RegulationDetailDto } from 'src/app/core/models/regulation/regulation-detail';
import { ChangeViewerDialogComponent } from 'src/app/views/distributed-ui-components/change-viewer-dialog/change-viewer-dialog.component';
import { RegulationService } from 'src/app/core/services/regulation';
import { BulkCloseModel } from 'src/app/core/models/regulation/bulk-close-model';
import { BulkCloseDialogComponent } from 'src/app/views/distributed-ui-components/bulk-close-dialog/bulk-close-dialog.component';
import { VersionHistoryFilterModel } from 'src/app/core/models/view-model/version-history-filter-model';
import { ImpactAssessmentDialogComponent } from 'src/app/views/impact-assessment/impact-assessment-dialog/impact-assessment-dialog.component';
import { DownloadReportModel } from 'src/app/core/models/view-model/download-report-model';
import { HttpErrorResponse } from '@angular/common/http';
import { revisionHistoryAccessTypeEnum } from 'src/app/core/models/ckEditor/revisionData';
import { ModalDialogComponent } from 'src/app/views/distributed-ui-components/modal-dialog/modal-dialog.component';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { FileType } from 'src/app/core/enums/user/file-type';

@Component({
  selector: 'app-impact-assessment-template5',
  templateUrl: './impact-assessment-template5.component.html',
  styleUrls: ['./impact-assessment-template5.component.scss']
})
export class ImpactAssessmentTemplate5Component {

  isAuthorised = true;
  isLoading = false;
  toastModel: ToastViewModel;
  isToastShow = false;
  selectable = true;
  removable = true;
  searchStr = '';
  addOnBlur = true;
  isSavedPermission = false;
  userJurisdiction: Array<FilterViewModel>;
  libraryMenu: Array<MenuItemModel>;
  currentUserRole = '';
  linkedAssessmentIds: Array<LinkedIdModel>;
  currentinfoId: number = 0;
  jurisdictions!: JurisdictionsList;
  searchedJurisdiction!: any[];
  isLoadingDD = false;
  isSaved = false;
  alertDialogModel: AlertDialogModel;
  isParentIdEdit = false;
  parentId = 0;
  isADetailPermission = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  ragRating: RagRating[];
  detailInput: string = "";
  engagementPlanInput: string = "";
  internalStakeholders: string = "";
  externalStakeholder: string = "";
  responseKeyInput: string = "";
  policyReformInput: string = "";
  accessType: revisionHistoryAccessTypeEnum | undefined;

  isSADetails1 = false;
  isSADetails2 = false;
  isSADetails3 = false;
  isSADetails4 = false;
  isSADetails5 = false;
  isSADetails6 = false;

  regulationInfo: RegulationDetail;
  isAssessmentClose = false;
  bulkCloseData: BulkCloseModel;
  downloadReportModel: DownloadReportModel;


  @Input()
  filterType!: string;
  @Input()
  impactAssessmentId!: number;
  filterScreenType = '';

  impactAssessment: ImpactAssessmentT5;
  iaDetailHistory: ImpactAssessmentT5DetailListModel;
  userAccessToken: UserProfile;
  impactAssessmentDD: ImpactAssessmentT5DetailsDD;
  updateIADetails: UpdateImpactAssessmentT5Model;

  responseLeadDD: string[] = [];
  accountableExecutiveDD: string[] = [];
  ruleTopicDD: string[] = [];

  @ViewChild('responseLeadAutocomplete')
  responseLeadAutocomplete!: MatAutocomplete;
  @ViewChild('responseLeadInput')
  responseLeadInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoResponseLead')
  trigautoResponseLead!: MatAutocompleteTrigger;
  searchResponseLeadCntrl: FormControl = new FormControl();
  searchedResponseLead: FilterViewModel[] = [];
  allSearchedResponseLead: FilterViewModel[] = [];

  @ViewChild('accountableExecutiveAutocomplete')
  accountableExecutiveAutocomplete!: MatAutocomplete;
  @ViewChild('accountableExecutiveInput')
  accountableExecutiveInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoAccountableExecutive')
  trigautoAccountableExecutive!: MatAutocompleteTrigger;
  searchAccountableExecutiveCntrl: FormControl = new FormControl();
  searchedAccountableExecutive: FilterViewModel[] = [];
  allSearchedAccountableExecutive: FilterViewModel[] = [];

  @ViewChild('topicAutocomplete')
  topicAutocomplete!: MatAutocomplete;
  @ViewChild('topicInput')
  topicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('trigautoTopicExecutive')
  trigautoTopicExecutive!: MatAutocompleteTrigger;
  searchTopicCntrl: FormControl = new FormControl();
  searchedTopic: FilterViewModel[] = [];
  allSearchedTopic: FilterViewModel[] = [];

  //Dropdowns
  team: Array<string> = [];
  currentStatus: Array<string> = [];
  consultationPeriod: Array<string> = [];
  responseApproach: Array<string> = [];
  engagementPlan: Array<string> = [];
  policyResponseAchieved: Array<string> = [];
  ruleType: Array<string> = [];

  //Document
  isAssessmentLoader = false;
  @ViewChild('myFileInput1') myFileInput1: any;
  @Input()
  idList: number[]=[];
  impactAssessmentDocument: Array<SelfAssessmentDocumentModel>;

  constructor(private ref: ChangeDetectorRef, private regulationService: RegulationService, public commonService: CommonService, private gdprService: GDPRService, public dialog: MatDialog, public router: Router, private sessionService: SessionService, public sanitizer: DomSanitizer, private impactService: ImpactService, private userService: UserManagementService) {
    this.toastModel = new ToastViewModel();
    this.impactAssessment = new ImpactAssessmentT5();
    this.iaDetailHistory = new ImpactAssessmentT5DetailListModel();
    this.userAccessToken = new UserProfile();
    this.impactAssessmentDD = new ImpactAssessmentT5DetailsDD();
    this.userJurisdiction = [];
    this.libraryMenu = [];
    this.linkedAssessmentIds = [];
    this.updateIADetails = new UpdateImpactAssessmentT5Model();
    this.alertDialogModel = new AlertDialogModel();
    this.ragRating = [];
    this.regulationInfo = new RegulationDetail();
    this.bulkCloseData = new BulkCloseModel();
    this.downloadReportModel = new DownloadReportModel();
    this.impactAssessmentDocument = [];
  }

  ngOnInit(): void {
    this.filterScreenType = this.filterType;
    this.getUserProfile();
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
      this.userAccessToken = result;
      this.checkUserIAAuthentication();
      if (this.userAccessToken) {
        this.fetchUserDetails();
      }
    });
  }

  checkUserIAAuthentication(): void {
    this.impactService.getIAUsers(this.impactAssessmentId).subscribe((result: string[]) => {
      this.isSavedPermission = result.indexOf(this.userAccessToken.fullName) >= 0 ? true : false;
    });
  }

  fetchUserDetails(): void {
    this.userService.getUserDetails().subscribe((result: UserDetailModel) => {
      this.userJurisdiction = result.userJurisdiction;
      this.libraryMenu = result.libraryMenu;
      this.currentUserRole = result && result.role.title ? result.role.title : '';
      this.fetchImpactAssessmentDetails();
      if (this.filterType !== 'version') {
        this.fetchIADetailsHistory();
      }
      // this.fetchJurisdiction();
      this.fetchImpactAssessmentDD();
    });
  }

  fetchImpactAssessmentDD(): void {
    this.isLoadingDD = true;
    this.impactService.getImpactAssessmentT5DD().subscribe((result: ImpactAssessmentT5DetailsDD) => {
      this.isLoadingDD = false;
      this.impactAssessmentDD = result;
      this.ddListData();
      this.selectedDDvalue();
    });
  }

  selectedDDvalue(): void {
    this.responseLeadDD = this.impactAssessment.responseLead ? this.impactAssessment.responseLead.split(',') : this.responseLeadDD;
    this.accountableExecutiveDD = this.impactAssessment.accountableExecutive ? this.impactAssessment.accountableExecutive.split(',') : this.accountableExecutiveDD;
    this.ruleTopicDD = this.impactAssessment.ruleTopic ? this.impactAssessment.ruleTopic.split(',') : this.ruleTopicDD;
  }

  ddListData(): void {
    this.searchedResponseLead = this.impactAssessmentDD.responseLead;
    this.searchedAccountableExecutive = this.impactAssessmentDD.accountableExecutive;
    this.searchedTopic = this.impactAssessmentDD.ruleTopics;

    this.allSearchedResponseLead = this.impactAssessmentDD.responseLead;
    this.allSearchedAccountableExecutive = this.impactAssessmentDD.accountableExecutive;
    this.allSearchedTopic = this.impactAssessmentDD.ruleTopics;

    this.searchResponseLeadCntrl.valueChanges.subscribe((term: any) => {
      this.searchedResponseLead = term ? this.filterResponseLead(term) : this.impactAssessmentDD.responseLead;
    });
    this.searchAccountableExecutiveCntrl.valueChanges.subscribe((term: any) => {
      this.searchedAccountableExecutive = term ? this.filterAccountableExecutive(term) : this.impactAssessmentDD.accountableExecutive;
    });
    this.searchTopicCntrl.valueChanges.subscribe((term: any) => {
      this.searchedTopic = term ? this.filterTopic(term) : this.impactAssessmentDD.ruleTopics;
    });
  }

  fetchImpactAssessmentDetails(): void {
    this.isLoading = true;
    this.impactService.getImpactAssessmentT5Details(this.impactAssessmentId, this.filterType)
      .subscribe((result: ImpactAssessmentT5) => {
        this.impactAssessment = result;
        this.ckEditorAccessManageFunction();
        let responseL: any[] = this.impactAssessment.responseLead ? this.impactAssessment.responseLead.split(',') : [];
        let accountableE: any[] = this.impactAssessment.accountableExecutive ? this.impactAssessment.accountableExecutive.split(',') : [];
        const set = new Set([...responseL, ...accountableE]);
        let newArray = Array.from(set);
        if (newArray.includes(this.userAccessToken.fullName) || this.currentUserRole == 'Compliance Enterprise') {
          this.isSavedPermission = true;
        }
        this.openEditor();
        this.getImpactAssesmentDropdownList(result.jurisdiction);
        this.getAssessmentDocuments();
        this.impactAssessment.ruleType = this.impactAssessment.ruleType ? this.impactAssessment.ruleType : 'Draft Rule';
        this.isLoading = false;
        if (this.impactAssessment.previousImpactAsss_Id) {
          // this.getLinkedIds();
        }
        this.fetchPermissionByJurisdiction(this.userJurisdiction);
        this.currentinfoId = this.impactAssessment.updatedDB_Id;
      });
  }

  getImpactAssesmentDropdownList(jurisdiction: string): void {
    this.impactService.getImpactAssesmentT5DropDownList(jurisdiction).subscribe((result: ImpactAssessmentT5DropDownList) => {
      result.team.forEach(element => {
        this.team.push(element.title)
      });
      result.ragRating.forEach(element => this.ragRating = JSON.parse(element.title));

      result.currentStatus.forEach(element => {
        this.currentStatus.push(element.title)
      });
      result.responseApproach.forEach(element => {
        this.responseApproach.push(element.title)
      });
      result.engagementPlan.forEach(element => {
        this.engagementPlan.push(element.title)
      });
      result.policyResponseAchieved.forEach(element => {
        this.policyResponseAchieved.push(element.title)
      });
      result.ruleType.forEach(element => {
        this.ruleType.push(element.title)
      });
    });
  }

  // fetchJurisdiction(): void {
  //   this.impactService.GetJurisdictionsList().subscribe((result: JurisdictionsList) => {
  //     this.jurisdictions = result;

  //     this.searchedJurisdiction = this.jurisdictions.jurisdictions;
  //   })
  // }

  getLinkedIds(): void {
    this.impactService.getLinkedIds(this.impactAssessment.previousImpactAsss_Id).subscribe((result: LinkedIdModel[]) => {
      this.linkedAssessmentIds = result;
    });
  }

  fetchPermissionByJurisdiction(userJurisdiction: FilterViewModel[]): void {
    if (this.currentUserRole !== 'Compliance Enterprise') {
      if (this.impactAssessment.jurisdiction) {
        const jurisArr = this.impactAssessment.jurisdiction.split(',');
        jurisArr.forEach(element => {
          if (!userJurisdiction.some(a => a.value === element)) {
            this.isAuthorised = false;
          }
        });
      }
    } else {
      this.isAuthorised = true;
    }
  }

  fetchIADetailsHistory(): void {
    this.impactService.getIAT5DetailsHistory(this.impactAssessmentId).subscribe((result: ImpactAssessmentT5DetailListModel) => {
      this.iaDetailHistory = result;
      if (this.iaDetailHistory.detail.length > 0 && this.iaDetailHistory.detail[0].itemTitle != null) {
        this.detailInput = this.iaDetailHistory.detail[0].itemTitle;
      }
      if (this.iaDetailHistory.engagementPlanDetails.length > 0 && this.iaDetailHistory.engagementPlanDetails[0].itemTitle != null) {
        this.engagementPlanInput = this.iaDetailHistory.engagementPlanDetails[0].itemTitle;
      }
      if (this.iaDetailHistory.internalStakeholdersPacks.length > 0 && this.iaDetailHistory.internalStakeholdersPacks[0].itemTitle != null) {
        this.internalStakeholders = this.iaDetailHistory.internalStakeholdersPacks[0].itemTitle;
      }
      if (this.iaDetailHistory.externalStakeHolderPositions.length > 0 && this.iaDetailHistory.externalStakeHolderPositions[0].itemTitle != null) {
        this.externalStakeholder = this.iaDetailHistory.externalStakeHolderPositions[0].itemTitle;
      }
      if (this.iaDetailHistory.responseKeyMessages.length > 0 && this.iaDetailHistory.responseKeyMessages[0].itemTitle != null) {
        this.responseKeyInput = this.iaDetailHistory.responseKeyMessages[0].itemTitle;
      }
      if (this.iaDetailHistory.policyReformSummery.length > 0 && this.iaDetailHistory.policyReformSummery[0].itemTitle != null) {
        this.policyReformInput = this.iaDetailHistory.policyReformSummery[0].itemTitle;
      }
    });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  @HostListener('window:scroll', ['$event'])
  scrollHandler(event: any) {
    if (this.responseLeadAutocomplete?.isOpen) {
      this.trigautoResponseLead.closePanel();
      this.responseLeadInput.nativeElement.blur();
    }
  }

  //ResponseLead
  addResponseLead(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.responseLeadAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.responseLeadDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.responseLeadDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchResponseLeadCntrl.setValue(null);
    }
  }
  selectedResponseLeadEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.responseLeadDD) {
      let sameValueRow = this.responseLeadDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.responseLeadDD.push(event.option.viewValue);
      }
    } else {
      this.responseLeadDD = [];
      this.responseLeadDD.push(event.option.viewValue);
    }
    if (this.responseLeadInput) {
      this.responseLeadInput.nativeElement.value = '';
    }
    this.searchResponseLeadCntrl.setValue(null);
    this.searchResponseLeadCntrl.disable();
    this.searchResponseLeadCntrl.enable();
    // this.updateSectionLastEdited('Assessor');
  }
  removeResponseLead(status: string): void {
    const index = (this.responseLeadDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.responseLeadDD as string[]).splice(index, 1);
      // this.updateSectionLastEdited('Assessor');
    }
  }
  filterResponseLead(search: string): any {
    return this.searchedResponseLead.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  //AccountableExecutive
  addAccountableExecutive(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.accountableExecutiveAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.accountableExecutiveDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.accountableExecutiveDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchAccountableExecutiveCntrl.setValue(null);
      // this.updateSectionLastEdited('Assessor');
    }
  }
  selectedAccountableExecutiveEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.accountableExecutiveDD) {
      let sameValueRow = this.accountableExecutiveDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.accountableExecutiveDD.push(event.option.viewValue);
      }
    } else {
      this.accountableExecutiveDD = [];
      this.accountableExecutiveDD.push(event.option.viewValue);
    }
    if (this.accountableExecutiveInput) {
      this.accountableExecutiveInput.nativeElement.value = '';
    }
    this.searchAccountableExecutiveCntrl.setValue(null);
    this.searchAccountableExecutiveCntrl.disable();
    this.searchAccountableExecutiveCntrl.enable();
    // this.updateSectionLastEdited('Assessor');
  }
  removeAccountableExecutive(status: string): void {
    const index = (this.accountableExecutiveDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.accountableExecutiveDD as string[]).splice(index, 1);
      // this.updateSectionLastEdited('Assessor');
    }
  }
  filterAccountableExecutive(search: string): any {
    return this.searchedAccountableExecutive.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  //Rule Topic
  addTopic(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.topicAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.ruleTopicDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.ruleTopicDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchTopicCntrl.setValue(null);
    }
  }
  selectedTopicEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.ruleTopicDD) {
      let sameValueRow = this.ruleTopicDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.ruleTopicDD.push(event.option.viewValue);
      }
    } else {
      this.ruleTopicDD = [];
      this.ruleTopicDD.push(event.option.viewValue);
    }
    if (this.topicInput) {
      this.topicInput.nativeElement.value = '';
    }
    this.searchTopicCntrl.setValue(null);
    this.searchTopicCntrl.disable();
    this.searchTopicCntrl.enable();
  }
  removeTopic(status: string): void {
    const index = (this.ruleTopicDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.ruleTopicDD as string[]).splice(index, 1);
    }
  }
  filterTopic(search: string): any {
    return this.searchedTopic.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  getFilteredData(filter: string, event: any): void {
    this.searchStr += event.key;
    switch (filter) {
      case 'ResponseLead':
        const searchedRL = Array<FilterViewModel>();
        if (this.searchedResponseLead.length > 0) {
          this.searchedResponseLead.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedRL.push(element);
            }
          });
          this.searchedResponseLead = searchedRL;
        } else {
          this.searchedResponseLead = this.allSearchedResponseLead;
        }
        break;
      case 'AccountableExecutive':
        const searchedAE = Array<FilterViewModel>();
        if (this.searchedAccountableExecutive.length > 0) {
          this.searchedAccountableExecutive.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedAE.push(element);
            }
          });
          this.searchedAccountableExecutive = searchedAE;
        } else {
          this.searchedAccountableExecutive = this.allSearchedAccountableExecutive;
        }
        break;
      case 'RuleTopic':
        const searchedRT = Array<FilterViewModel>();
        if (this.searchedTopic.length > 0) {
          this.searchedTopic.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedRT.push(element);
            }
          });
          this.searchedTopic = searchedRT;
        } else {
          this.searchedTopic = this.allSearchedTopic;
        }
        break;
    }
    this.searchStr = '';
  }
  updateImpactAssessmentDetails(): void {
    this.isSaved = true;
    this.isLoading = true;

    if (this.ruleTopicDD.length > 0 && this.impactAssessment.currentStatus != null) {
      if (this.impactAssessment.isRecordTime) {
        const dialogRef = this.dialog.open(TimePickerComponent, {
          width: '330px',
          panelClass: 'custom-time-modal'
        });

        dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
            this.impactAssessment.timeSpent = this.impactAssessment.timeSpent + result;
          }
        });
      }

      this.impactAssessment.accountableExecutive = this.accountableExecutiveDD.toString();
      this.impactAssessment.responseLead = this.responseLeadDD.toString();
      this.impactAssessment.ruleTopic = this.ruleTopicDD.toString();
      //Have to to for Topic also

      //Date Fields
      this.impactAssessment.resposeDeadline = this.impactAssessment.resposeDeadline ?
        MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.resposeDeadline.toString()) : null;
      this.impactAssessment.effectiveDate = this.impactAssessment.effectiveDate ?
        MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.effectiveDate.toString()) : null;
      this.impactAssessment.responseSubmissionDate = this.impactAssessment.responseSubmissionDate ?
        MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.responseSubmissionDate.toString()) : null;
      this.impactAssessment.nextActionDate = this.impactAssessment.nextActionDate ?
        MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.nextActionDate.toString()) : null;

      this.impactAssessment.userId = this.userAccessToken.externalUserId;
      this.impactAssessment.userName = this.userAccessToken.fullName;
      const currentUrl = window.location.href;
      this.impactAssessment.lastUpdatedTime = MasterHelper.getDate(0);
      this.updateIADetails.impactAssessment = this.impactAssessment;
      this.closeEditor();
      this.impactService.updateImpactAssessmentT5(this.updateIADetails, currentUrl).subscribe((result: ImpactAssessmentT5) => {
        this.isLoading = false;
        this.impactAssessment = result;
        this.alertMessage('success', 'Successfully updated');
        this.isSaved = false;
        this.updateIADetails = new UpdateImpactAssessmentT5Model();
        this.fetchIADetailsHistory();
        this.ckEditorAccessManageFunction();
        this.openEditor();
        if (result.previousImpactAsss_Id) {
          this.getLinkedIds();
        }
      });
    }
    else {
      this.alertMessage('warning', '* fields are required.');
      this.isSaved = false;
      this.isLoading = false;
    }
  }

  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }

  updateOtherMergedId(item: any) {
    this.openDeleteDialogForLinkedId(item);
  }
  openDeleteDialogForLinkedId(item: any): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this Linked Id ' + item + ' ?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Delete Item') {
        item = Number(item);
        const bulkInsertModel = new BulkInsertModel();
        bulkInsertModel.screenUrl = this.router.url;
        let itemids = this.impactAssessment.merged_Id.replace('(', '');
        itemids = itemids.replace(')', '');
        bulkInsertModel.itemIds = itemids.split(",").map(Number);
        const index = bulkInsertModel.itemIds.indexOf(item);
        bulkInsertModel.itemIds.splice(index, 1);
        bulkInsertModel.parentId = this.impactAssessment.updatedDB_Id;
        bulkInsertModel.id = this.impactAssessment.id;
        this.isLoading = true;
        this.gdprService.moveToBulkImpactAssessment5(bulkInsertModel).subscribe((data: any) => {
          this.isLoading = false;
          let otherIds = bulkInsertModel.itemIds.map(x => x).join(",");
          this.impactAssessment.merged_Id = otherIds;
        });
      }
    });
  }

  updateParentId() {
    this.parentId = this.impactAssessment.updatedDB_Id;
    this.isParentIdEdit = true;
  }
  changeParentId() {
    const bulkInsertModel = new BulkInsertModel();
    bulkInsertModel.screenUrl = this.router.url;
    let itemids = this.impactAssessment.merged_Id.replace('(', '');
    itemids = itemids.replace(')', '');
    bulkInsertModel.itemIds = itemids.split(",").map(Number);
    bulkInsertModel.parentId = this.parentId;
    bulkInsertModel.id = this.impactAssessment.id;
    if (this.impactAssessment.updatedDB_Id != this.parentId) {
      this.isLoading = true;
      this.gdprService.moveToBulkImpactAssessment5(bulkInsertModel).subscribe((data: any) => {
        this.impactAssessment.updatedDB_Id = this.parentId;
        this.isParentIdEdit = false;
        this.isLoading = false;
      });
    }
    else {
      this.isParentIdEdit = false;
    }
  }

  getBackgroundColor(itemTitle: string): string {
    const selectedOption = this.ragRating.find(option => option.itemTitle === itemTitle);
    return selectedOption ? selectedOption.color : '';
  }

  updateSectionLastEdited() {
    if (this.impactAssessment.resposeDeadline && this.impactAssessment.updatedDB_Date) {
      const updatedDBDate = new Date(this.impactAssessment.updatedDB_Date);
      const differenceMs = this.impactAssessment.resposeDeadline.getTime() - updatedDBDate.getTime();
      const differenceWeeks = differenceMs / (1000 * 60 * 60 * 24 * 7);
      const roundedWeeks = Math.round(differenceWeeks);
      this.impactAssessment.consultationPeriod = roundedWeeks + " Weeks";
    }
    else {
      this.impactAssessment.consultationPeriod = "";
    }
    this.ref.detectChanges();
  }

  openRegulationDialog(): void {
    this.regulationInfo.regulationId = this.impactAssessment.updatedDB_Id;
    this.regulationInfo.title = this.impactAssessment.title;
    this.regulationInfo.type = this.impactAssessment.pubType;
    this.regulationInfo.filterType = 'Linked Updates';
    this.regulationInfo.TabType = this.filterScreenType;
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: this.regulationInfo
    });
    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        this.isAssessmentClose = true;
        if (result.selectedLinkedIds && result.selectedLinkedIds.length > 0) {
          result.selectedLinkedIds.push(this.impactAssessment.updatedDB_Id);
          this.bulkCloseRegulations(result, 'Close');
        } else {
          this.updateRegulationDetail(result, this.impactAssessment.updatedDB_Id);
        }
      } else {
        this.regulationInfo = new RegulationDetail();
      }
    });
  }

  updateRegulationDetail(regulation: RegulationDetail, id: number): void {
    regulation.regulationId = id;
    regulation.userId = this.userAccessToken.externalUserId;
    regulation.isRead = true;
    regulation.status = +regulation.status;
    const regDto = new RegulationDetailDto();
    regDto.regulationDetails = regulation;
    regDto.screenName = 'Impact Assessment Details';
    this.regulationService.moveToRegulationDetail(regDto).subscribe(() => {
      this.alertMessage('success', 'Successfully updated');
      if (this.isAssessmentClose) {
        if (this.router.url.indexOf('/impact-assessment/details/') >= 0) {
          this.router.navigate([
            "/impact-assessment/summary/"
          ]);
        }
        else if (this.router.url.includes('/change-viewer')) {
          this.dialog.closeAll();
        }
        this.isAssessmentClose = false;
      }
    });
    //}
  }

  bulkCloseRegulations(regDetails: RegulationDetail, filter: string): void {
    this.bulkCloseData.itemIds = regDetails.selectedLinkedIds;
    regDetails.userId = this.userAccessToken.externalUserId;
    regDetails.isRead = true;
    this.bulkCloseData.regulationDetail = regDetails;
    if (this.bulkCloseData.itemIds && this.bulkCloseData.itemIds.length > 50) {
      this.warningAlert('This operation may take a while to complete. The page will refresh upon completion. Please wait...');
    }
    this.bulkCloseData.regulationDetail.title = '';
    this.regulationService.regulationBulkClose(this.bulkCloseData).subscribe((result: any) => {
      this.alertMessage('success', 'Successfully updated');
      if (this.isAssessmentClose) {
        if (this.router.url.indexOf('/impact-assessment/details/') >= 0) {
          this.router.navigate([
            "/impact-assessment/summary/"
          ]);
        }
        else if (this.router.url.includes('/change-viewer')) {
          this.dialog.closeAll();
        }
        this.isAssessmentClose = false;
      }
    });
  }

  warningAlert(msg: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  openBulkCloseDialog(): void {
    let itemids;
    if (this.impactAssessment.isMerged) {
      itemids = this.impactAssessment.merged_Id.replace('(', '');
      itemids = itemids.replace(')', '');
    }
    const dialogRef = this.dialog.open(BulkCloseDialogComponent, {
      width: '750px',
      data: itemids ? itemids.split(",").map(Number) : ''
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.bulkCloseImpactAssessment(result, 'BulkClose');
      }
    });
  }

  bulkCloseImpactAssessment(regDetails: RegulationDetail, filter: string): void {
    this.isLoading = true;
    let selectedItems: any;
    if (this.impactAssessment.isMerged) {
      selectedItems = this.impactAssessment.merged_Id.replace('(', '')
      selectedItems = selectedItems.replace(')', '');
      selectedItems = selectedItems.split(",").map(Number)
    }
    this.bulkCloseData.itemIds = filter === 'BulkClose' ? selectedItems : regDetails.selectedLinkedIds;
    regDetails.userId = this.userAccessToken.externalUserId;
    regDetails.isRead = true;
    this.bulkCloseData.regulationDetail = regDetails;
    if (this.bulkCloseData.itemIds && this.bulkCloseData.itemIds.length > 50) {
      this.warningAlert('This operation may take a while to complete. The page will refresh upon completion. Please wait...');
    }
    this.bulkCloseData.regulationDetail.title = '';
    this.bulkCloseData.impactId = this.impactAssessment.id;
    this.regulationService.moveBulkImpactAssessmentT4BulkClose(this.bulkCloseData).subscribe((result: any) => {
      this.saveOnBrowser('_iadid', JSON.stringify(selectedItems));
      if (result.message === 'Saved Successfully') {
        this.alertMessage('success', 'Successfully updated');
        //Need to change here after Summary page is done.
        if (this.router.url.indexOf('/impact-assessment/details/') >= 0) {
          this.router.navigate([
            "/impact-assessment/summary/"
          ]);
        }
        else if (this.router.url.includes('/change-viewer')) {
          this.dialog.closeAll();
        }
      } else {
        this.warningAlert(result.message);
      }
      this.isLoading = false;
    });
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  openDialog(): void {
    const filterDataModel = new VersionHistoryFilterModel();
    filterDataModel.id = this.impactAssessment.id;
    filterDataModel.versionId = this.impactAssessmentId;
    filterDataModel.filterType = this.filterScreenType;
    filterDataModel.templateNo = this.impactAssessment.templateNo;
    const dialogRef = this.dialog.open(ImpactAssessmentDialogComponent, {
      width: '750px',
      data: filterDataModel
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (this.filterScreenType === 'PopupWindow' && result) {
        this.filterType = 'version';
        this.impactAssessmentId = +result;
        this.fetchImpactAssessmentDetails();
        // this.fetchJurisdiction();
        this.fetchImpactAssessmentDD();
      }
    });
  }

  backToCurrentVersion(): void {
    if (this.filterScreenType === 'PopupWindow') {
      this.filterType = this.filterScreenType;
      this.impactAssessmentId = this.impactAssessment.id;
      this.fetchImpactAssessmentDetails();
      this.fetchIADetailsHistory();
      // this.fetchJurisdiction();
      this.fetchImpactAssessmentDD();
    } else {
      window.location.href = 'impact-assessment/details/impact/' + this.impactAssessment.templateNo + '/' + this.impactAssessment.id;
    }
  }

  downloadReport(): void { //Have to do API changes in Switch case for Template 5 and for that reason commented out this function in HTML
    this.isLoading = true;
    this.downloadReportModel.id = this.impactAssessmentId;
    const parsedUrl = new URL(window.location.href);
    this.downloadReportModel.currentUrl = parsedUrl.origin;
    this.impactService.downloadIAReport(this.downloadReportModel)
      .subscribe((data: any) => {
        this.isLoading = false;
        // tslint:disable-next-line:one-variable-per-declaration
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `ImpactAssessmentReport.csv`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      });
  }
  getUpdatedDbInfo(id: number) {
    if (this.currentinfoId != id) {
      this.isLoading = true;
      this.impactService.getImpactAssessmentRegulationDetails(id).subscribe((data: ImpactAssessmentT5) => {
        this.impactAssessment.title = data.title;
        this.impactAssessment.description = data.description;
        this.impactAssessment.pubType = data.pubType;
        this.impactAssessment.geography = data.geography;
        this.impactAssessment.regulator = data.regulator;
        this.impactAssessment.updatedDB_Date = data.updatedDB_Date;
        this.impactAssessment.country = data.country;
        this.currentinfoId = id;
        this.isLoading = false;
      });
    }

  }
  ckEditorAccessManageFunction() {
    let responseL: any[] = this.impactAssessment.responseLead ? this.impactAssessment.responseLead.split(',') : [];
    let accountableE: any[] = this.impactAssessment.accountableExecutive ? this.impactAssessment.accountableExecutive.split(',') : [];
    const set = new Set([...responseL, ...accountableE]);
    let newArray = Array.from(set);
    if (newArray.includes(this.userAccessToken.fullName) || this.currentUserRole == 'Compliance Enterprise') {
      this.accessType = revisionHistoryAccessTypeEnum.All;
    }
    else {
      this.accessType = revisionHistoryAccessTypeEnum.Readonly;
    }
  }
  openEditor() {
    this.isSADetails1 = true;
    this.isSADetails2 = true;
    this.isSADetails3 = true;
    this.isSADetails4 = true;
    this.isSADetails5 = true;
    this.isSADetails6 = true;
  }
  closeEditor() {
    this.isSADetails1 = false;
    this.isSADetails2 = false;
    this.isSADetails3 = false;
    this.isSADetails4 = false;
    this.isSADetails5 = false;
    this.isSADetails6 = false;
  }

  uploadEvidenceAssessment(fileInputBlock: string): void {
    const fileInput = document.getElementById(fileInputBlock) as HTMLElement;
    fileInput.click();
  }
  fetchImpactAssessmentDocuments(): void {
    this.isAssessmentLoader = true;
    this.impactService.getImpactAssessmentDocumentsT5(this.impactAssessmentId).subscribe((result: SelfAssessmentDocumentModel[]) => {
      this.impactAssessmentDocument = result;
      this.isAssessmentLoader = false;
    });
  }
  getAssessmentDocuments(): void {
    this.isAssessmentLoader = true;
    this.impactService.getImpactAssessmentDocumentsT5(this.impactAssessmentId).subscribe((result: SelfAssessmentDocumentModel[]) => {
      this.impactAssessmentDocument = result;
      this.isAssessmentLoader = false;
    });
  }
  removeImpactAssessmentDocuments(id: number): void {
    this.isAssessmentLoader = true;
    this.impactService.deleteImpactAssessmentDocumentT5(id).subscribe((data: any) => {
      this.isAssessmentLoader = false;
      this.fetchImpactAssessmentDocuments();
      if (data.result) {
        this.alertMessage('success', data.result);
      }
    });
  }
  public FileType = FileType;
  uploadFileToActivity(fileToUpload: any, fileType: FileType): void {
    let template = 5;
    this.isAssessmentLoader = true;
    this.impactService.uploadEvidence(fileToUpload, fileType, this.impactAssessmentId, template).subscribe((data: any) => {
      this.fetchImpactAssessmentDocuments();
      this.isAssessmentLoader = false;
    }, (err: HttpErrorResponse) => {
      this.isAssessmentLoader = false;
      this.alertMessage('warning', 'File not uploaded, please check your file');
      setTimeout(() => {
      }, 1000);
    });
  }
  downloadDocument(id: number, fileName: string, extension: string): void {
    let template = 5;
    this.isAssessmentLoader = true;
    this.impactService.downloadEvidence(id, template)
      .subscribe((data: any) => {
        this.isAssessmentLoader = false;
        // tslint:disable-next-line:one-variable-per-declaration
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `${fileName}${extension}`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      });
  }
  handleFileInput(files: FileList, fileType: FileType): void {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], fileType);
    }
    this.myFileInput1.nativeElement.value = '';
  }
  openDeleteModel(id: number): void {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to delete?',
        title: 'Delete Document',
        btnText: 'Delete',
      }
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.removeImpactAssessmentDocuments(id);
      }
    });
  }
  //previous next button add
  checkSibling(id: number, type: string): boolean {
    const index = this.idList.findIndex((a) => Number(a)=== Number(id));
    if (index < 0) {
      return false;
    } else {
      if (type === 'Next') {
        return this.idList[index + 1] ? true : false;
      } else {
        return this.idList[index - 1] ? true : false;
      }
    }
  }
  getSiblings(type: string): void {
   
    const index = this.idList.findIndex(
      (a) => Number(a) === Number(this.impactAssessmentId));
    if (type === 'Next') {
      this.impactAssessmentId = this.idList[index + 1];
    } else {
      this.impactAssessmentId = this.idList[index - 1];
    }
    this.redirectLink();
  }
  redirectLink() {
    let link = '/impact-assessment/details/impact/'+this.impactAssessment.templateNo+'/' + this.impactAssessmentId + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
   this.router.navigate([link], navigationExtras);
  }
}
